// vm-author-profile.js
// "Show more" reveal for sections/vm-author-profile.liquid. All matching
// articles are already present in the DOM (crawlable); this just unhides
// the overflow past the initial reveal count on click.
(function () {
  var btn = document.getElementById('vm-author-show-more');
  if (!btn) return;
  btn.addEventListener('click', function () {
    document.querySelectorAll('.vm-author-post--hidden').forEach(function (el) {
      el.classList.remove('vm-author-post--hidden');
    });
    btn.parentElement.style.display = 'none';
  });
})();
